// @mui
import { enUS, frFR, zhCN, viVN, arSD } from '@mui/material/locale';
// components
import { SettingsValueProps } from './components/settings/type';

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_BANNER_HEIGHT: 90,
  DASHBOARD_DESKTOP_BANNER_HEIGHT_COLLAPSED: 45,
  DASHBOARD_DESKTOP_UNDER_BANNER_HEIGHT: 45,
  DASHBOARD_DESKTOP_UNDER_BANNER_HEIGHT_COLLAPSED: 0,
  DASHBOARD_DESKTOP_HEIGHT: 85,
  DASHBOARD_DESKTOP_TITLE_HEIGHT: 70,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 75 - 32,
  DASHBOARD_MARGIN: 10,
  DASHBOARD_RADIUS: 20,
  DASHBOARD_HEADER_TITLE_MARGIN: 150,
  DASHBOARD_VIEW_HEADER: 110,
  DASHBOARD_NAVIGATION_MENU: 50,
  DASHBOARD_NAVIGATION_PAGE_MENU: 50,
  DASHBOARD_VIEW_PAGE_TIMEPERIOD: 128
};

export const IMPERSONATION_BANNER_HEIGHT = 40;

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 220,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
  //
  DASHBOARD_MARGIN: 10,
  DASHBOARD_MARGIN_TOP: HEADER.DASHBOARD_DESKTOP_HEIGHT + HEADER.DASHBOARD_MARGIN * 2,

  //
  DASHBOARD_RADIUS: 10
};

const SIDEBAR_MAP = {
  MARGIN_TOP: 200
}

const SIDEBAR_DETAIL_MAP = {
  MARGIN_TOP: 150
}

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'blue',
  themeStretch: false,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'Vietnamese',
    value: 'vn',
    systemValue: viVN,
    icon: '/assets/icons/flags/ic_flag_vn.svg',
  },
  {
    label: 'Chinese',
    value: 'cn',
    systemValue: zhCN,
    icon: '/assets/icons/flags/ic_flag_cn.svg',
  },
  {
    label: 'Arabic (Sudan)',
    value: 'ar',
    systemValue: arSD,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
];

const defaultLang = allLangs[0]; // English


export const AUTOCOMPLETE_CONFIG = {
  pageSize: 35,
  page: 0,
}

export const PAGINATION_CONFIG = {
  pageSize: 100,
  page: 0,
}

export const LOCAL_STORAGE_KEY = {
  sentEmail: 'sentEmail',
}